<template>
    <div>
        <v-col cols="12">
            <button class="button back-to-list" @click="backToList">
                <v-icon>mdi-arrow-left</v-icon>
                <span class="text">Back To List</span>
            </button>
        </v-col>
        <v-col cols="12">
            <h2>{{ id ? t('roles::page.title.edit-dms-role') : t('roles::page.title.new-dms-role') }}</h2>
        </v-col>
        <v-col cols="12">
            <dms-roles-tabs></dms-roles-tabs>
            <dms-roles-tabs-items></dms-roles-tabs-items>
        </v-col>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: false,
            default: null,
        },
    },
    created() {
        if (this.can('api.v1.acl-routes.grouped')) {
            this.$store.dispatch('dms_roles/loadPermissionsOptions');
            this.loadRole();
        }
    },
    methods: {
        backToList() {
            return this.$root.goTo(route('roles.index'));
        },
        loadRole() {
            if (!this.id) {
                return;
            }
            axios
                .get(
                    route('api.v1.roles.show', {
                        role: this.id,
                        fields: 'id,name,group,acl_routes,reset_password,description,readonly,active',
                    })
                )
                .then((response) => {
                    this.role = response.data.data;
                    const currentRole = response.data.data;
                    if (currentRole.acl_routes && currentRole.acl_routes.length) {
                        currentRole.acl_routes = response.data.data.acl_routes.map((x) => x.id);
                    }
                    this.$store.dispatch('dms_roles/loadDmsRole', currentRole);
                    this.selected = this.role.acl_routes ? this.role.acl_routes.map((route) => route.id) : [];
                    this.roleOriginalState = _.clone(this.role);
                });
        },
    },
};
</script>

<style scoped>
label {
    margin-bottom: 0 !important;
}

.v-input--selection-controls {
    margin-top: 8px;
}
</style>
